import { render, staticRenderFns } from "./ApuracaoContratoTabelaFornecedor.vue?vue&type=template&id=2e0fe67a"
import script from "./ApuracaoContratoTabelaFornecedor.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoTabelaFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoContratoTabelaFornecedor.vue?vue&type=style&index=0&id=2e0fe67a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports